import { computed, Injectable } from '@angular/core';
import { ComponentStoreV2Factory } from '../../../../shared/store/common/component-store-v2.factory';
import { currentValid } from '../../../../shared/pipes/currentValid.pipe';
import { selectCurrentOrganization } from '../../../../../store/global/global.selectors';

@Injectable()
export class ServiceBasicInfoFormStore2 extends ComponentStoreV2Factory {

    private readonly organization = this.store.selectSignal(selectCurrentOrganization);

    public readonly centerOptions = computed(() => (this.organization()?.centers ?? [])
        .filter(center => !center.primary)
        .map(center => ({
            id: center.id,
            name: currentValid(center.basicInfos)?.name ?? String(center.id),
        })))
    ;
}
